import  './projectCards.css'
import React from 'react'

const projectcards = (props) => {
  return (
    <div className='project_card'>
  <div className='project-card'>
       <div className="project-thumb">

          {props.video ? (
            <video
              src={props.video}
              autoPlay
              muted
              loop
              playsInline
            />
          ) : (
            props.thumbLabel
          )}

        </div>
      <div className="project-body">
        <h3>{props.title}</h3>
        <p>{props.desc}</p>
        <div className="tag-row">
          {props.tags.map((tag) => (
            <span className="tag" key={tag}>{tag}</span>
          ))}
        </div>
        <a href={props.link} className="project-link">View Project →</a>
      </div>
    </div>
</div>
  )
}

export default projectcards


